import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import PaymentsReport from "./payment_report.js";
import Loading from "../helpers/loading_component.js";
import { secretKey } from "../.././data";

const MySwal = withReactContent(Swal2);

const PaymentsArchive = (props) => {
  const [showPaymentReport, setShowPaymentsReport] = useState(false);
  const [search, setSearch] = useState("");
  const [searchID, setSearchID] = useState("");
  const [searchMail, setSearchMail] = useState("");
  const [payments, setPayments] = useState([]);
  const [payments2, setPayments2] = useState([]);
  const [paymentReportValue, setPaymentsReportValue] = useState("");
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("all");
  const [paymentsClear, setPaymentsClear] = useState([]);
  const [expandMobileFilters, setExpandMobileFilters] = useState(false);

  const handleExpandMobileChange = () => {
    setExpandMobileFilters(!expandMobileFilters);
  };

  const handleShowPaymentReport = (e) => {
    setShowPaymentsReport(!showPaymentReport);
  };

  const handleSearchChange = (e) => {
    setSearchMail("");
    setSearchID("");
    setSearch(e.target.value);
    if (e.target.value === "") {
      setPayments(payments2);
    } else {
      setPayments(
        payments2.filter((el) =>
          el.name
            .toString()
            .toLowerCase()
            .includes(e.target.value.toString().toLowerCase())
        )
      );
    }
  };

  const handleSearchIdChange = (e) => {
    setSearch("");
    setSearchMail("");
    setSearchID(e.target.value);
    if (e.target.value === "") {
      setPayments(payments2);
    } else {
      setPayments(
        payments2.filter((el) =>
          el.identifier
            .toString()
            .toLowerCase()
            .includes(e.target.value.toString().toLowerCase())
        )
      );
    }
  };

  const handleSearchMailChange = (e) => {
    setSearch("");
    setSearchID("");
    setSearchMail(e.target.value);
    if (e.target.value === "") {
      setPayments(payments2);
    } else {
      setPayments(
        payments2.filter((el) =>
          el.email
            .toString()
            .toLowerCase()
            .includes(e.target.value.toString().toLowerCase())
        )
      );
    }
  };

  const handleRowClick = (e) => {
    e.preventDefault();
    var value = e.currentTarget.attributes.value.value;
    setPaymentsReportValue(value);
    handleShowPaymentReport();
  };

  const handleFilterChange = (e) => {
    setSearchMail("");
    setSearch("");
    setSearchID("");
    setFilter(e.target.value);

    if (e.target.value === "not_connected") {
      setPayments(paymentsClear.filter((el) => el.clientId === ""));
      setPayments2(paymentsClear.filter((el) => el.clientId === ""));
    } else if (e.target.value === "all") {
      setPayments(paymentsClear);
      setPayments2(paymentsClear);
    }
  };

  const handleSortChange = (e) => {
    if (e.target.value === "f1a") {
      setPayments(
        payments.sort(
          (a, b) => parseInt(b.to_settlement) - parseInt(a.to_settlement)
        )
      );
    } else if (e.target.value === "f1b") {
      setPayments(
        payments.sort(
          (a, b) => parseInt(a.to_settlement) - parseInt(b.to_settlement)
        )
      );
    } else if (e.target.value === "f2a") {
      setPayments(
        payments.sort((a, b) => parseInt(b.delay_time) - parseInt(a.delay_time))
      );
    } else if (e.target.value === "f2b") {
      setPayments(
        payments.sort((a, b) => parseInt(a.delay_time) - parseInt(b.delay_time))
      );
    } else if (e.target.value === "f3a") {
      setPayments(
        payments.sort(
          (a, b) =>
            new Date(a.first_payment_date) - new Date(b.first_payment_date)
        )
      );
    } else if (e.target.value === "f3b") {
      setPayments(
        payments.sort(
          (a, b) =>
            new Date(b.first_payment_date) - new Date(a.first_payment_date)
        )
      );
    } else if (e.target.value === "f4a") {
      setPayments(payments2);
    }
  };

  const handleFilterChangeRefresh = (data) => {
    if (filter === "not_connected") {
      setPayments(data.filter((el) => el.clientId === ""));
      setPayments2(data.filter((el) => el.clientId === ""));
    } else if (filter === "all") {
      setPayments(data);
      setPayments2(data);
    }
  };

  const fetchPaymentsArchive = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getPayments", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        data = getAllowedClients(data.filter((el) => el.archive_date));
        setPayments(
          data.sort(
            (a, b) => parseInt(b.to_settlement) - parseInt(a.to_settlement)
          )
        );
        setPayments2(
          data.sort(
            (a, b) => parseInt(b.to_settlement) - parseInt(a.to_settlement)
          )
        );
        setPaymentsClear(
          data.sort(
            (a, b) => parseInt(b.to_settlement) - parseInt(a.to_settlement)
          )
        );
        handleFilterChangeRefresh(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getAllowedClients = (data) => {
    if (props.upData.allowedClients === "all") {
      return data;
    } else {
      var allowed = props.upData.allowedClients
        .toString()
        .replaceAll(" ", "")
        .split(",");
      var arr = [];
      allowed.map((el) => {
        arr = arr.concat(data.filter((el2) => +el2.clientId === +el));
      });
      return arr;
    }
  };

  useEffect(() => {
    setLoading(true);
    fetchPaymentsArchive();
  }, []);

  const paymentsArchiveData = (
    <>
      <table className="payments_table">
        <tr key={0}>
          <th>ID</th>
          <th>Imię i nazwisko</th>
          <th>Adres e-mail</th>
          <th>Numer telefonu</th>
          <th>Do rozliczenia</th>
          <th>Ilość rat</th>
          <th>Kwota wpłacona</th>
          <th>Ilość wpłaconych rat</th>
          <th>Ilość oczekiwanych rat</th>
          <th>Data ostatniej płatności</th>
          <th>Data archiwizacji</th>
        </tr>
        {payments.map((el) => (
          <>
            <tr value={el.identifier} onClick={handleRowClick}>
              <td>{el.id}</td>
              <td>{el.name}</td>
              <td>{el.email}</td>
              <td>{el.phone}</td>
              <td>{el.to_settlement}</td>
              <td>{el.installment}</td>
              <td>{el.pay_sum}</td>
              <td>{el.pay_count}</td>
              <td>{el.pay_expected_count}</td>
              <td>{el.last_pay_date}</td>
              <td>{el.archive_date}</td>
            </tr>
          </>
        ))}
      </table>
    </>
  );

  const paymentsDataMobile = (
    <>
      <table className="clients_table">
        <tr key={0}>
          <th style={{ fontSize: "3vw" }}>ID</th>
          <th style={{ fontSize: "3vw" }}>Imię i nazwisko</th>
          <th style={{ fontSize: "3vw" }}>Data archiwizacji</th>
        </tr>
        {payments.map((el) => (
          <>
            <tr
              id={
                el.to_archive === "TAK"
                  ? "archiveRow"
                  : +el.delay_time > 10
                  ? "overdatedRow"
                  : +el.delay_time <= 10 && el.to_archive !== "TAK"
                  ? "yellowRow"
                  : el.pay_sum === undefined
                  ? "newRow"
                  : ""
              }
              key={el.id}
            >
              <td>{el.identifier}</td>
              <td value={el.identifier} onClick={handleRowClick}>
                {el.name}
              </td>
              <td>{el.archive_date}</td>
            </tr>
          </>
        ))}
      </table>
    </>
  );

  const desktopFilters = (
    <>
      <div className="closeButtonBoxNotePopUp">
        <div className="searchBoxP">
          <label>Wyszukaj po imieniu i nazwisku</label>
          <input
            type="text"
            id="name"
            name="name"
            value={search}
            onChange={handleSearchChange}
          />
        </div>
        <div className="searchBoxP">
          <label>Wyszukaj po ID</label>
          <input
            type="text"
            id="name"
            name="name"
            value={searchID}
            onChange={handleSearchIdChange}
          />
        </div>
        <div className="searchBoxP">
          <label>Wyszukaj po adresie e-mail</label>
          <input
            type="text"
            id="name"
            name="name"
            value={searchMail}
            onChange={handleSearchMailChange}
          />
        </div>
        <div className="filterBoxP">
          <label>Filtrowanie</label>
          <select
            type="text"
            id="filterP"
            name="court"
            value={filter}
            onChange={handleFilterChange}
          >
            <option key={0} value="all">
              Wszystkie
            </option>
            <option key={4} value="not_connected">
              Niepowiązane
            </option>
          </select>
        </div>
        <div className="filterBoxP">
          <label>Sortowanie</label>
          <select
            type="text"
            id="filterP"
            name="court"
            onChange={handleSortChange}
          >
            <option key={0} value="f1a">
              Kwota do rozliczenia - od największej
            </option>
            <option key={1} value="f1b">
              Kwota do rozliczenia - od najmniejszej
            </option>
            <option key={2} value="f2a">
              Ilość dni po terminie - od największej
            </option>
            <option key={3} value="f2b">
              Ilość dni po terminie - od najmniejszej
            </option>
            <option key={4} value="f3a">
              Data pierwszej płatności - od najstarszej
            </option>
            <option key={5} value="f3b">
              Data pierwszej płatności - od najmłodszej
            </option>
          </select>
        </div>
      </div>
    </>
  );

  const mobileFilters = (
    <>
      <div
        style={
          expandMobileFilters
            ? { display: "flex", width: "100%", padding: "3vh 0" }
            : { display: "flex", width: "100%", padding: "3vh 0" }
        }
      >
        <div style={{ width: "100%" }}>
          <button
            className="calendarUserButton"
            style={{ width: "100%", justifyContent: "center" }}
            onClick={handleExpandMobileChange}
          >
            {!expandMobileFilters ? "ROZWIŃ FILTRY" : "ZWIŃ FILTRY"}
          </button>
        </div>
      </div>
      {expandMobileFilters ? (
        <>
          <div className="closeButtonBoxNotePopUp">
            <div className="searchBoxP">
              <label>Wyszukaj po imieniu i nazwisku</label>
              <input
                type="text"
                id="name"
                name="name"
                value={search}
                onChange={handleSearchChange}
              />
            </div>
            <div className="searchBoxP">
              <label>Wyszukaj po ID</label>
              <input
                type="text"
                id="name"
                name="name"
                value={searchID}
                onChange={handleSearchIdChange}
              />
            </div>
            <div className="searchBoxP">
              <label>Wyszukaj po adresie e-mail</label>
              <input
                type="text"
                id="name"
                name="name"
                value={searchMail}
                onChange={handleSearchMailChange}
              />
            </div>
            <div className="filterBoxP">
              <label>Filtrowanie</label>
              <select
                type="text"
                id="filterP"
                name="court"
                value={filter}
                onChange={handleFilterChange}
              >
                <option key={0} value="all">
                  Wszystkie
                </option>
                <option key={4} value="not_connected">
                  Niepowiązane
                </option>
              </select>
            </div>
            <div className="filterBoxP">
              <label>Sortowanie</label>
              <select
                type="text"
                id="filterP"
                name="court"
                onChange={handleSortChange}
              >
                <option key={0} value="f1a">
                  Kwota do rozliczenia - od największej
                </option>
                <option key={1} value="f1b">
                  Kwota do rozliczenia - od najmniejszej
                </option>
                <option key={2} value="f2a">
                  Ilość dni po terminie - od największej
                </option>
                <option key={3} value="f2b">
                  Ilość dni po terminie - od najmniejszej
                </option>
                <option key={4} value="f3a">
                  Data pierwszej płatności - od najstarszej
                </option>
                <option key={5} value="f3b">
                  Data pierwszej płatności - od najmłodszej
                </option>
              </select>
            </div>
          </div>
        </>
      ) : (
        ""
      )}
    </>
  );

  return (
    <>
      <div className="mainContainerTransactions">
        {loading ? (
          <Loading />
        ) : (
          <>
            {showPaymentReport ? (
              <PaymentsReport
                close={handleShowPaymentReport}
                paymentsData={payments}
                paymentsSheetData={props.paymentsSheetData}
                transactionsSheetData={props.transactionsSheetData}
                transactionsData={props.transactionsData}
                paymentsArchiveSheetData={props.paymentsArchiveSheetData}
                paymentsArchiveData={props.paymentsArchiveData}
                id={paymentReportValue}
                refreshData={props.refreshData}
                place="arch"
                team={props.team}
                logClientAction={props.logClientAction}
                checkPermissions={props.checkPermissions}
                lawyersData={props.lawyersData}
                courtsData={props.courtsData}
                banksData={props.banksData}
                upData={props.upData}
                users={props.users}
                userRole={props.upData.role}
              />
            ) : (
              ""
            )}
            {!showPaymentReport ? (
              <>
                <div className="closeButtonBoxNotePopUp">
                  <div className="closeButtonBoxNotePopUp_col1">
                    Lista płatności archiwalnych - ilość rekordów{" "}
                    {payments.length}
                  </div>
                </div>
                <div className="desktopFilters">{desktopFilters}</div>
                <div className="mobileFilters">{mobileFilters}</div>
                <span className="noteModuleP">
                  kliknij w rekord, aby zobaczyć szczegóły
                </span>
                <div className="contentBoxPayments">
                  <div className="desktopFilters">{paymentsArchiveData}</div>
                  <div className="mobileFilters">{paymentsDataMobile}</div>
                </div>
              </>
            ) : (
              ""
            )}
          </>
        )}
      </div>
    </>
  );
};

export default PaymentsArchive;
